import * as Types from '../../../__generated__/types.generated';

import { gql } from '@apollo/client';
import { ContactFragmentOnContactFeedFragmentDoc } from '../../../crm/contacts/__generated__/contact-fragment.generated';
import { StepImageUploadOnFeedFragmentDoc } from '../../../media/step-image-uploads/__generated__/step-image-upload.fragment.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type RemoveStepImageUploadFromContentMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type RemoveStepImageUploadFromContentMutation = { __typename?: 'RootMutationType', removeStepImageUploadFromContent?: { __typename?: 'ContentResult', content?: { __typename?: 'Content', id: string, type: Types.ContentType, groupType: Types.ContentGroupType, body?: any | null, label?: string | null, plainDescription?: string | null, embedLink?: string | null, oembedResult?: any | null, providerName?: string | null, videoContain?: boolean | null, video?: { __typename?: 'VideoUpload', id: string, rawUrl?: string | null, transcodedUrl?: string | null, previewUrl?: string | null, streamUrl?: string | null, gifUrl?: string | null, gifWithIconUrl?: string | null, contact?: { __typename?: 'Contact', id: string, email?: string | null, firstName?: string | null, lastName?: string | null, title?: string | null, avatarThumbUrl?: string | null, insertedAt?: any | null, company?: { __typename?: 'Company', id: string, name: string, iconUrl?: string | null, thumbUrl?: string | null } | null } | null } | null, image?: { __typename?: 'StepImageUpload', id: string, name?: string | null, originalUrl?: string | null, fhdUrl?: string | null, alternativeText?: string | null, size?: number | null, insertedAt?: any | null, width?: number | null, height?: number | null, originalWidth?: number | null, originalHeight?: number | null } | null } | null, userErrors?: Array<{ __typename?: 'UserError', field: string, message: string } | null> | null } | null };


export const RemoveStepImageUploadFromContentDocument = gql`
    mutation removeStepImageUploadFromContent($id: ID!) {
  removeStepImageUploadFromContent(id: $id) {
    content {
      id
      type
      groupType
      body
      label
      plainDescription
      embedLink
      oembedResult
      providerName
      videoContain
      video {
        id
        rawUrl
        transcodedUrl
        previewUrl
        streamUrl
        gifUrl
        gifWithIconUrl
        contact {
          ...ContactFragmentOnContactFeed
        }
      }
      image {
        ...StepImageUploadOnFeed
      }
    }
    userErrors {
      field
      message
    }
  }
}
    ${ContactFragmentOnContactFeedFragmentDoc}
${StepImageUploadOnFeedFragmentDoc}`;
export type RemoveStepImageUploadFromContentMutationFn = Apollo.MutationFunction<RemoveStepImageUploadFromContentMutation, RemoveStepImageUploadFromContentMutationVariables>;

/**
 * __useRemoveStepImageUploadFromContentMutation__
 *
 * To run a mutation, you first call `useRemoveStepImageUploadFromContentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveStepImageUploadFromContentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeStepImageUploadFromContentMutation, { data, loading, error }] = useRemoveStepImageUploadFromContentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveStepImageUploadFromContentMutation(baseOptions?: Apollo.MutationHookOptions<RemoveStepImageUploadFromContentMutation, RemoveStepImageUploadFromContentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveStepImageUploadFromContentMutation, RemoveStepImageUploadFromContentMutationVariables>(RemoveStepImageUploadFromContentDocument, options);
      }
export type RemoveStepImageUploadFromContentMutationHookResult = ReturnType<typeof useRemoveStepImageUploadFromContentMutation>;
export type RemoveStepImageUploadFromContentMutationResult = Apollo.MutationResult<RemoveStepImageUploadFromContentMutation>;
export type RemoveStepImageUploadFromContentMutationOptions = Apollo.BaseMutationOptions<RemoveStepImageUploadFromContentMutation, RemoveStepImageUploadFromContentMutationVariables>;